
define(
	'Code25.CaterpartsGlobal.DeliveryCosts'
	, [
		"Handlebars", "Utils", "Code25.CaterpartsGlobal.DeliveryCosts.View"
	]
	, function (
		Handlebars, Utils, Code25CaterpartsGlobalDeliveryCostsView
	) {
		'use strict';

		return {
			mount: function mount(container) {

				var layout = container.getComponent('Layout');
				layout.registerView('DeliveryCosts', function () {
					return new Code25CaterpartsGlobalDeliveryCostsView({ application: container });
				});

			}
		};

	});
